"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/portal/examples/index.ts';
var PortalExample = /** @class */ (function () {
    function PortalExample() {
        this.isOpen = false;
    }
    PortalExample.prototype.view = function () {
        var _this = this;
        var card = (0, mithril_1.default)(_1.Card, { elevation: 4 }, (0, mithril_1.default)('', 'This content is taken out of document flow.'));
        return (0, mithril_1.default)(examples_1.Example, { src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Button, {
                intent: 'primary',
                label: this.isOpen ? 'Hide Portal' : 'Show Portal',
                onclick: function () { return _this.isOpen = !_this.isOpen; }
            }),
            this.isOpen && (0, mithril_1.default)(_1.Portal, { style: 'position: absolute; top:10px; left: 10px' }, card)
        ]);
    };
    return PortalExample;
}());
exports.PortalExample = PortalExample;
